import styled from "styled-components";
import { useState } from "react";
import { ExecutionData } from "../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { BaseTestResultData } from "../../rule-engine-core/Common/Testing/BaseTestResultData";
import { TestResultDataType } from "../../rule-engine-core/Common/Testing/TestResultDataType";
import { FormConfiguration } from "../FormConfiguration";
import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";
import { FormContext } from "../Utilities/FormContext";
import { TextareaAutosize } from "@mui/material";
import { OpenReverseIcon } from "../../CommonUI/Icon/OpenReverseIcon";
import { OpenBlueIcon } from "../../CommonUI/Icon/OpenBlueIcon";
import { FormMode } from "../Utilities/FormDesignConstants";
import { TestResult } from "../../CommonUI/Testing/TestResult";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export class FormTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.FORM;

    form: FormConfiguration;
    formContext: FormContext;

    startData: ExecutionData;

    constructor(form: FormConfiguration, data?: ExecutionData, result?: string) {
        super(form._id, result);
        this.form = form;
        this.formContext = new FormContext(form);
        this.formContext.mode = FormMode.Runtime;
        form.setFormContext(this.formContext);
        this.startData = data ? new ExecutionData(data.values) : new ExecutionData();
        this.formContext.setFormData(data ?? new ExecutionData());
    }
}

export const FormUI = ({ renderUI, context }: { renderUI: () => JSX.Element; context: FormContext }) => {
    const [openDataLayer, setOpenDataLayer] = useState<boolean>(true);

    const [showResult, setShowResult] = useState<boolean>(false);

    context.resultPromise.then(() => {
        setShowResult(true);
    });

    return (
        <>
            <FormUIRender>
                <FormDataRender>
                    <OpenButton onClick={() => setOpenDataLayer(!openDataLayer)}>
                        {openDataLayer ? <OpenReverseIcon /> : <OpenBlueIcon />}
                    </OpenButton>

                    {openDataLayer && (
                        <ObserveState
                            listenTo={context}
                            control={() => (
                                <TextareaAutosize
                                    data-testid="runtime-json-textarea"
                                    value={JSON.stringify(context.data.values, null, 2)}
                                    style={{
                                        width: "100%",
                                        border: "solid 1px " + UIStyleConstants.GRAY_LIGHTER_COLOR,
                                        borderRadius: "5px",
                                        color: UIStyleConstants.TEXT_COLOR_DEFAULT,
                                    }}
                                    minRows={20}
                                />
                            )}
                        />
                    )}
                </FormDataRender>
                <FormRender>{renderUI()}</FormRender>
            </FormUIRender>
            {showResult ? <TestResult executableId={context.form._id} /> : null}
        </>
    );
};

const FormUIRender = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    overflow: hidden;
`;

const FormRender = styled.div`
    flex: 1;
    overflow: auto;

    padding: 15px;
`;

const FormDataRender = styled.div`
    position: relative;
`;

const OpenButton = styled.div`
    width: 16px;
    height: 16px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    left: 100%;
    top: 0;

    background: ${UIStyleConstants.WHITE_COLOR};
`;
